module.exports = __webpack_public_path__ + "img/Phi beta sigma 1994.f90e00af.jpg";